import AbstarctView from '../framework/view/abstract-view';

const createFilmListTemplate = () => '<section class="films-list"><h2 class="films-list__title visually-hidden">All movies. Upcoming</h2></section>';

export default class FilmListView extends AbstarctView {
  get template() {
    return createFilmListTemplate();
  }
}
